<template>
  <div>
    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class="flex">
        <el-select
          v-if="theUserProject == 0"
          v-model="theProjectId"
          @change="theProjectAllChange"
          size="small"
          clearable
          placeholder="请选择项目"
        >
          <el-option
            v-for="item in getProjectList_data.data || []"
            :key="item.projectId"
            :label="item.projectName"
            :value="item.projectId"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="getUserMemorandumList_data.umName"
          placeholder="请输入名称"
          clearable
          size="small"
          style="max-width:380px;"
        />
        <el-button
          v-click.getUserMemorandumList
          type="primary"
          icon="el-icon-search"
          size="small"
          style="margin-left:10px;"
          >搜索
        </el-button>
        <el-dropdown
        v-if="theProjectId"
          size="small"
          split-button
          type="warning"
          style="margin-left: 10px;width: 100px;"
          @click="Out()"
          @command="Out"
        >
          导出
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              style="background-color: #E6A23C;color: white;"
              command="1"
              >导出全部</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          v-click.toStopAudio
          type="primary"
          icon="el-icon-search"
          size="small"
          style="margin-left:10px;"
          >停止播放
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums="tableColums_getUserMemorandumList"
      api="getUserMemorandumList ::umId"
      updateapi="updateCircleLetter"
      :height="H - 165"
      ref="getUserMemorandumListTable"
    >
    </mytable>
  </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
export default {
  data() {
    return {
      baseUrl: $Api.baseUrl_online,
      csAttrId: null,
      audio: null,
      theProjectId: "",
      theUserProject: "",
      tableColums_getUserMemorandumList: {
        $selection: true,

        umName: "标题",

        umTimeNum: "语音长度",

        createtime: "创建时间",

        $operation: [
          "操作",
          200,
          `@text: 播放#success
           @click: play($row)
          `
        ]
      }
    };
  },

  watch: {},

  methods: {
    openLoading() {
      //loading请求等待
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    Out(e) {
      if (e) {
        const bulkdata = {
          projectId: this.theProjectId,
          exportType: 1
        };
        this.openLoading();
        var s = qs.stringify(bulkdata);
        var that = this;
        axios({
          method: "post",
          url:that.baseUrl + "/opportunity/user-memorandum/exportUserMemorandum",
          data: s,
          withCredentials: true,
          timeout: 1200000,
          responseType: "arraybuffer",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            token: A.local("$Usertoken"),
            projectId: +A.local("$projectId")
          }
        }).then(function(res) {
          if (res.data) {
            that.loading.close();
            let a = document.createElement("a");
            //ArrayBuffer 转为 Blob
            let blob = new Blob([res.data], {
              type: "application/zip"
            });
            console.log(blob);
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", "录音.zip");
            a.click();
            that.$message({
              message: "成功",
              type: "success"
            });
            // that.BulkClose()
          }
        });
      } else {
        const selection = Object.keys(
          this.$refs.getUserMemorandumListTable.$MyTableCache
        );
        if (selection.length === 0) return alertWarn("请选择您要导出的数据！");

        console.log(selection.join());
        const bulkdata = {
          projectId: this.theProjectId,
          exportType: 2,
          umIds: selection.join()
        };
        this.openLoading();
        var s = qs.stringify(bulkdata);
        var that = this;
        axios({
          method: "post",
          url:that.baseUrl + "/opportunity/user-memorandum/exportUserMemorandum",
          data: s,
          withCredentials: true,
          timeout: 1200000,
          responseType: "blob",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            token: A.local("$Usertoken"),
            projectId: +A.local("$projectId")
          }
        }).then(function(res) {
          if (res.data) {
            that.loading.close();
            let a = document.createElement("a");
            //ArrayBuffer 转为 Blob
            let blob = new Blob([res.data], {
              type: "application/zip"
            });
            console.log(blob);
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", "录音");
            a.click();
            that.$message({
              message: "成功",
              type: "success"
            });
            // that.BulkClose()
          }
        });
      }
    },

    play(row) {
      if (this.audio != null && !this.audio.paused) {
        this.audio.pause();
      }
      if (this.audio == null) {
        this.audio = new Audio();
      }
      this.audio.src = row.umUrl;
      this.audio.play();
    },
    toStopAudio() {
      if (this.audio != null && !this.audio.paused) {
        this.audio.pause();
      }
    },
    theProjectAllChange(e) {
      this.theProjectId = e;
      this.getUserMemorandumList({ projectId: this.theProjectId });
    }
  },

  created() {
    this.theUserProject = A.local("$projectId");
    if (this.theUserProject == 0) {
      this.getProjectList({ pageSize: 0 });
    } else {
      this.theProjectId = this.theUserProject;
    }
    this.getUserMemorandumList({ projectId: this.theProjectId });
  },
  mounted() {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/help/MemorandumManage.vue